import { render, staticRenderFns } from "./BookColumnFeed.vue?vue&type=template&id=475ec442&scoped=true&"
import script from "./BookColumnFeed.vue?vue&type=script&lang=js&"
export * from "./BookColumnFeed.vue?vue&type=script&lang=js&"
import style0 from "./BookColumnFeed.vue?vue&type=style&index=0&id=475ec442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475ec442",
  null
  
)

export default component.exports